<template>
  <div class="profile">
    <div class="left">
      <a @click="handleBloggerProfileClick">
        <img
          v-if="blog.blogger && blog.blogger.imgURL"
          :src="blog.blogger.imgURL"
          :alt="`${blog.blogger.firstname} ${blog.blogger.lastname} image`"
        />
      </a>
      <div>
        <h3
          @click="handleBloggerProfileClick"
          class="name"
          v-if="blog.blogger && blog.blogger.firstname"
        >
          {{ blog.blogger.firstname + " " + blog.blogger.lastname }}
        </h3>
        <p class="detail" v-if="bloggerProfileBio">
          {{ bloggerProfileBio }}
        </p>
      </div>
    </div>
    <button
      class="btn-follow"
      :class="isFollowed ? 'followed' : ''"
      @click="$emit('followClicked')"
    >
      <span v-if="!isFollowed">FOLLOW</span>
      <span v-else>FOLLOWING</span>
    </button>
  </div>
</template>

<script>
import config from "@/assets/_config.json";
export default {
  name: "AuthorProfileThumb",
  data() {
    return {
      config
    };
  },
  props: ["blog", "blogger", "isFollowed"],
  computed: {
    bloggerProfileBio() {
      if (this.blogger && this.blogger.profile && this.blogger.profile.bio) {
        const ellipses =
          this.blogger.profile.bio.length > this.config.limit.blogger_profile
            ? "..."
            : "";
        return `${this.blogger.profile.bio.substr(
          0,
          this.config.limit.blogger_profile
        )} ${ellipses}`;
      }
      return null;
    }
  },
  methods: {
    handleBloggerProfileClick() {
      this.$router.push(`/blog/crew/@${this.blogger.profile.profileName}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.profile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 45px;
  .left {
    display: grid;
    grid-template-columns: 80px 1fr;
    grid-column-gap: 24px;
    img {
      cursor: pointer;
      height: 80px;
      width: 80px;
      border-radius: 50%;
      object-fit: cover;
    }
    .name {
      cursor: pointer;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 26px;
      color: #474d52;
      margin-bottom: 8px;
      cursor: pointer;
    }
    .detail {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #8d99a0;
      max-width: 70%;
    }
  }
  .btn-follow {
    border: 1px solid #474d52;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 5px;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #474d52;
    background-color: #fff;
    transition: 0.2s ease;
    &:hover {
      background-color: #474d52;
      color: #fff;
      &:after,
      &:before {
        content: none;
      }
    }
  }
  .followed {
    color: #fff;
    background: #474d52;
  }
}
</style>
